const GA_ID = process.env.REACT_APP_GA4_ID;
const PIXEL_ID = process.env.REACT_APP_META_PIXEL_ID;
const CONSENT_KEY = "rivanta_analytics_consent";
const META_STANDARD = new Set(["ViewContent", "Lead"]);

export const analyticsConfigured = () => Boolean(GA_ID || PIXEL_ID);
export const getConsent = () => {
  try { return localStorage.getItem(CONSENT_KEY); } catch { return null; }
};

let loaded = false;
const pending = [];
function loadScript(src) {
  const s = document.createElement("script");
  s.async = true;
  s.src = src;
  document.head.appendChild(s);
}

export function loadTrackers() {
  if (loaded || getConsent() !== "granted") return;
  loaded = true;
  if (GA_ID) {
    loadScript(`https://www.googletagmanager.com/gtag/js?id=${GA_ID}`);
    window.dataLayer = window.dataLayer || [];
    window.gtag = function gtag() { window.dataLayer.push(arguments); };
    window.gtag("js", new Date());
    window.gtag("config", GA_ID);
  }
  if (PIXEL_ID && !window.fbq) {
    const fbq = function () { fbq.callMethod ? fbq.callMethod.apply(fbq, arguments) : fbq.queue.push(arguments); };
    fbq.push = fbq; fbq.loaded = true; fbq.version = "2.0"; fbq.queue = [];
    window.fbq = fbq; window._fbq = fbq;
    loadScript("https://connect.facebook.net/en_US/fbevents.js");
    window.fbq("init", PIXEL_ID);
    window.fbq("track", "PageView");
  }
}

export function setConsent(value) {
  try { localStorage.setItem(CONSENT_KEY, value); } catch { /* ignore */ }
  if (value === "granted") {
    loadTrackers();
    pending.splice(0).forEach(([n, p, id]) => sendToTrackers(n, p, id));
  } else pending.length = 0;
}

function sendToTrackers(name, params, eventId) {
  if (window.gtag) window.gtag("event", name, params);
  if (window.fbq) {
    const opts = eventId ? { eventID: eventId } : undefined;
    if (META_STANDARD.has(name)) window.fbq("track", name, params, opts);
    else window.fbq("trackCustom", name, params, opts);
  }
}

export function track(name, params = {}, eventId) {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({ event: name, ...params });
  const consent = getConsent();
  if (consent === "granted") sendToTrackers(name, params, eventId);
  else if (!consent && analyticsConfigured()) pending.push([name, params, eventId]);
}

export function trackOnce(name, params = {}, scope = "") {
  const key = `rivanta_evt_${name}_${scope}`;
  try {
    if (sessionStorage.getItem(key)) return;
    sessionStorage.setItem(key, "1");
  } catch { /* ignore */ }
  track(name, params);
}

export const trackCta = (label, location) => track("cta_click", { label, location });
